import React, { useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import LoginImage from "../Assets/images/Login_image.png";
import logo from "../Assets/images/logo.png";
import { useDispatch } from "react-redux";
import { loginApi } from "../Components/Auth0/Login/loginSlice";
import { useNavigate } from "react-router-dom";
import { AuthOHelper } from "../Common/Config";
import { ToastContainer, toast } from "react-toastify";

const LoginModal = (props) => {
  const { setStatus, show, setUserDetails, setEmailStatus } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loginPayload, setLoginPayload] = useState({});
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleSubmit = async () => {
    if (
      document.getElementById("emailInput").checkValidity() &&
      document.getElementById("passwordInput").checkValidity()
    ) {
      setLoading(true);
      try {
        const result = await AuthOHelper().post(`/user/login`, loginPayload);
        if (result.status === 200) {
          setUserDetails(result.data.data);
          localStorage.setItem("userData", JSON.stringify(result.data.data));
          localStorage.setItem(
            "token",
            JSON.stringify(result.data.data.accessToken)
          );
          dispatch(loginApi(result.data.data));
          toast.success(result.data.message);
          navigate("/checkout");
          props.setLoginDisplay(false);
          props.setLogedIn(true);
          setStatus(false);
          setLoading(false);
          setEmailStatus(false);
        }
      } catch (error) {
        toast.error(error.response.data.error);
        setLoading(false);
        props.setLoginDisplay(true);
        props.setLogedIn(false);
      }
    }
    setValidated(true);
  };
  const handleChange = (e) => {
    setLoginPayload({
      ...loginPayload,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <ToastContainer />
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => setStatus(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo} alt="logo" className="cursor_pointer" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Card.Title className="h6 my-4 ">Customer Login</Card.Title>

            <Col md={6} xl={6} lg={6}>
              <img src={LoginImage} alt="AbouImg" className="Login_Img" />
            </Col>
            <Col
              md={6}
              xl={6}
              lg={6}
              className="About_Card_Para black_text p-5"
            >
              <Form validated={validated}>
                <Form.Group className="mt-4">
                  <Form.Label className="text-muted">
                    <small>Username (email address)</small>
                  </Form.Label>
                  <Form.Control
                    required
                    type="email"
                    id="emailInput"
                    placeholder="name@example.com"
                    name="email"
                    onChange={handleChange}
                    className="Login_InputFields"
                  />
                  <Form.Label className="text-muted mt-4">
                    <small>Password</small>
                  </Form.Label>
                  <Form.Control
                    required
                    type="password"
                    placeholder="password"
                    name="password"
                    id="passwordInput"
                    onChange={handleChange}
                    className="Login_InputFields"
                  />
                  <Button
                    variant="link"
                    className="forget_Password mt-4"
                    onClick={() => navigate("/forgetPassword")}
                  >
                    <small>Forget Password?</small>
                  </Button>
                  <br />
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button className="SignIn_Btn mt-2 blue_bg" onClick={handleSubmit}>
            {loading ? (
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              ""
            )}
            Sign In
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LoginModal;
